import { hDeepClone } from '@/utils/helpers';
import ShButton from '@/components/Helpers/ShButton';
import ShPopconfirm from '@/components/Helpers/ShPopconfirm';
import DepartmentSign from '@/components/Common/DepartmentSign';
import AssignedAgentsPreview from './AssignedAgentsPreview';

// @vue/component
export default {
  name: 'DepartmentsListItem',

  components: {
    ShButton,
    ShPopconfirm,
    DepartmentSign,
    AssignedAgentsPreview,
  },

  props: {
    department: {
      type: Object,
      default: () => ({}),
    },
    agents: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      editableDepartment: hDeepClone(this.department),
      isWaitingForToggleActivity: false,
    };
  },

  computed: {
    assignedAgents() {
      if (this.department.assigned_agents) {
        const inDepartment = this.department.assigned_agents.split(',');
        return this.agents.filter(agent => inDepartment.includes(String(agent.id)));
      }
      return [];
    },
    canBeActivated() {
      return this.assignedAgents.length > 0;
    },
  },

  methods: {
    handleAssigmentOfAgents() {
      this.$EventBus.$emit('DepartmentsListItem/EDIT_ASSIGMENT_OF_AGENTS', this.department);
    },
    handleEditDepartments() {
      this.$EventBus.$emit('DepartmentsListItem/EDIT_DEPARTMENT', this.department);
    },
    async handleToogleDepartmentActivity() {
      this.isWaitingForToggleActivity = true;
      try {
        const params = {
          id: this.editableDepartment.id,
          is_active: !this.editableDepartment.is_active || 'false',
        };
        await this.$store.dispatch('departments/update', params);
        this.$set(this.editableDepartment, 'is_active', !this.editableDepartment.is_active);
        this.isWaitingForToggleActivity = false;
        this.$notify.success({
          title: this.editableDepartment.is_active ? 'Włączono dostępność Działu' : 'Wyłączono dostępność Działu',
          message: `Dostępność Działu ${this.editableDepartment.name} została ${this.editableDepartment.is_active ? 'włączona' : 'wyłączona'}`,
          customClass: 'callmeweb-notification',
        });
      } catch (error) {
        this.isWaitingForToggleActivity = false;
      }
    },
    async handleDeleteDepartment() {
      await this.$store.dispatch('departments/delete', this.editableDepartment.id);
      await this.$store.dispatch('departments/getList');
    },
  },
};
